import {useEffect} from "react";
import {Control, Controller} from "react-hook-form";
import {Checkbox} from "primereact/checkbox";
import {classNames} from "primereact/utils";
import {RequestType} from "../../models/Request";
import "./CheckboxInput.scss";

export interface CheckboxInputProps {
    id: string;
    checked: boolean;
    onValueChange: (property: string, value: boolean) => void;
    labelText: string;
    control: Control;
    setValue?: any;
    errors: any;
    rules?: any;
    colorType?: string;
    disabled?: boolean;
};

export const CheckboxInput = (p: CheckboxInputProps) => {
    const {
        id,
        checked,
        onValueChange,
        labelText,
        control,
        setValue,
        errors,
        rules,
        colorType,
        disabled
    } = p;

    useEffect(() => {
        if (setValue) setValue(labelText, checked)
    }, [checked]);

    return (
        <div className="checkbox-input">
            <label
                className={classNames("checkbox-label", {
                    'p-error': errors[labelText], 
                })}
                htmlFor={id}
            >
                {labelText}
            </label>
            <Controller
                name={labelText}
                control={control}
                rules={rules}
                render={({ field, fieldState }) => (
                    <Checkbox
                        {...field}
                        id={id}
                        checked={checked}
                        onChange={(e)=>{
                            field.onChange(e);
                            onValueChange(id, e.checked)}
                        }
                        disabled={disabled}
                        className={classNames(
                            { 'checkbox-input-field-request-import': colorType === RequestType.Import },
                            { 'checkbox-input-field-request-export': colorType === RequestType.Export },
                            { 'checkbox-input-field-request-relocation': colorType === RequestType.Relocation },
                            { 'p-invalid': fieldState.invalid }
                        )}
                    />
                )}
            />
        </div>
    );
};
